import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BASE_LON, BASE_LAT } from "./globe";

const ROT_RANGE = 8;
const CURSOR_LAT_RANGE = 5;
const SCROLL_LAT_RANGE = 12;
const SMOOTHING = 0.05;
const ENTRY_MS = 1800;
const ENTRY_START = 95;

export function initInteractions(stage, projection, redraw, ready) {
    const reducedMotion = matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

    let targetLon = 0;
    let currentLon = 0;
    let cursorLat = 0;
    let scrollLat = 0;
    let t0 = null;

    if (!reducedMotion) {
        stage.addEventListener("pointermove", (e) => {
            const rect = stage.getBoundingClientRect();
            const dx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
            const dy = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
            targetLon = -dx * ROT_RANGE;
            // Cursor down → tilt globe so north pole leans away (lat negative).
            cursorLat = dy * CURSOR_LAT_RANGE;
        });
        // No reset on pointerleave — map freezes at last cursor-derived position
        // so there's no visible snap-back. Re-enter picks up smoothly from there.

        // Scroll-driven latitude tilt: progress 0 (stage at bottom of viewport)
        // → 1 (stage at top), mapped to -RANGE..+RANGE.
        ScrollTrigger.create({
            trigger: stage,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            onUpdate: (self) => {
                scrollLat = (self.progress - 0.5) * 2 * SCROLL_LAT_RANGE;
            },
        });
    }

    ready.then(() => {
        t0 = performance.now();
        // Restart CSS @keyframes for entry zoom now that content exists
        const svg = stage.querySelector("[data-svg]");
        if (svg) {
            svg.style.animation = "none";
            void svg.offsetWidth;
            svg.style.animation = "";
        }
    });

    function entryOffset(now) {
        if (reducedMotion) return 0;
        if (t0 === null) return ENTRY_START;
        const t = Math.min(1, (now - t0) / ENTRY_MS);
        const eased = 1 - Math.pow(1 - t, 3);
        return ENTRY_START * (1 - eased);
    }

    let currentLat = 0;

    function tick(now) {
        const targetLat = scrollLat + cursorLat;
        currentLon += (targetLon - currentLon) * SMOOTHING;
        currentLat += (targetLat - currentLat) * SMOOTHING;
        projection.rotate([
            BASE_LON + currentLon + entryOffset(now),
            BASE_LAT + currentLat,
            0,
        ]);
        redraw();
        requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
}
